var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
var cls = classNames('dot');
export var DotDefaultProps = {
  color: 'primary',
  textColor: 'light',
  size: 28,
  strokeWidth: 3,
  fontSizeMultiplier: 0.7
};
// -------- Styles -------->
var ContainerStyles = breakpoints({
  base: css(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n    display: flex;\n    ", "\n  "], ["\n    display: flex;\n    ", "\n  "])), function (_a) {
    var stroke = _a.stroke,
      fill = _a.fill,
      strokeWidth = _a.strokeWidth,
      textColor = _a.textColor,
      size = _a.size,
      fontSizeMultiplier = _a.fontSizeMultiplier;
    return css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n      border-radius: 50%;\n      border-style: solid;\n      border-width: ", "px;\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n      font-size: ", ";\n      width: ", "px;\n      height: ", "px;\n      align-items: center;\n      justify-content: center;\n      box-sizing: border-box;\n    "], ["\n      border-radius: 50%;\n      border-style: solid;\n      border-width: ", "px;\n      background: ", ";\n      border-color: ", ";\n      color: ", ";\n      font-size: ", ";\n      width: ", "px;\n      height: ", "px;\n      align-items: center;\n      justify-content: center;\n      box-sizing: border-box;\n    "])), strokeWidth, theme.COLOR(fill), theme.COLOR(stroke), theme.COLOR(textColor), theme.FONT_SIZE(fontSizeMultiplier * size), size, size);
  })
});
// -------- Components -------->
var My = {
  Container: styled.span(templateObject_3 || (templateObject_3 = __makeTemplateObject(["", ""], ["", ""])), ContainerStyles)
};
export var Dot = function (props) {
  var className = props.className,
    children = props.children,
    stroke = props.stroke,
    strokeWidth = props.strokeWidth,
    size = props.size,
    fill = props.fill,
    color = props.color,
    textColor = props.textColor,
    fontSizeMultiplier = props.fontSizeMultiplier;
  var containerProps = {
    stroke: stroke || color,
    strokeWidth: strokeWidth,
    size: size,
    fill: fill || color,
    textColor: textColor,
    fontSizeMultiplier: fontSizeMultiplier
  };
  return React.createElement(My.Container, __assign({}, containerProps, {
    className: cls.name(className)
  }), children);
};
Dot.defaultProps = DotDefaultProps;
Dot.cls = cls;
var templateObject_1, templateObject_2, templateObject_3;